import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0538',
    ecrans: ['00-2'],
    params: ['?unpcleint','?demcleint']
});
